import { render, staticRenderFns } from "./GroupFormPage.vue?vue&type=template&id=4c174046&scoped=true&"
import script from "./GroupFormPage.vue?vue&type=script&lang=js&"
export * from "./GroupFormPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupFormPage.vue?vue&type=style&index=0&id=4c174046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c174046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c174046')) {
      api.createRecord('4c174046', component.options)
    } else {
      api.reload('4c174046', component.options)
    }
    module.hot.accept("./GroupFormPage.vue?vue&type=template&id=4c174046&scoped=true&", function () {
      api.rerender('4c174046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/GroupFormPage.vue"
export default component.exports